import React, { lazy, Suspense } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { handleKeyDown } from "views/utilities/enterFunctionForPOS";
import { CircularProgress, Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import { baseUrl } from "config";
import { redirectUrl } from "config";
import { setSalesItem } from "./slice/masterSlice";
import { updateSelected } from "./slice/posHeaderSlice";
import { useState } from "react";
import { CommonPrivFilter } from "utils/Privileges";

const SalesHeader = lazy(() => import("./components/SalesHeader"));
const TableSection = lazy(() => import("./components/TableSection"));
const Footer = lazy(() => import("./components/Footer"));

const SkeletonLoader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(1),
  height: "30px", // Adjust the height as needed
}));

const CardWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary[800],
  minHeight: "calc(100vh - 50px)",
  maxHeight: "100%",
  overflow: "hidden",
  position: "relative",
  "&:before": {
    content: '""',
    zIndex: 0,
    position: "absolute",
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${theme.palette.primary.dark} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
    borderRadius: "50%",
    top: -30,
    right: -100,
  },
  "&:after": {
    content: '""',
    position: "absolute",
    zIndex: -1,
    width: 210,
    height: 210,
    background: `linear-gradient(140.9deg, ${theme.palette.primary.dark} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
    borderRadius: "50%",
    top: -140,
    right: -60,
  },
}));

const customerOutletDealer = "/getMasterAndSalesItem";
const getBatch = "/getBatch";

function SalesPos() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const listPrivCustomer = CommonPrivFilter("inventory-sales-b2b-customerlist");

  const userDetail = useSelector((state) => state.common.userDetail);
  const isRestaurant = useSelector((state) => state.common.IsRestaurant);

  console.log(isRestaurant);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${baseUrl}${customerOutletDealer}?hasPrivilege=${listPrivCustomer?.canRead}`,
          {
            withCredentials: true,
          },
        );
        dispatch(setSalesItem(res?.data));
        const sortedCustomer =
          (res?.data?.[0] || [])
            .slice()
            .sort((a, b) => a?.Name?.localeCompare(b?.Name)) || null;

        const findCash = sortedCustomer?.find(
          (item) => item.Name === "CASH" || null,
        );
        dispatch(
          updateSelected({
            customer: isRestaurant ? findCash : null,
          }),
        );
        console.log(
          res?.data?.[1]?.find((dealer) => dealer.Name === userDetail.user),
          res?.data?.[1],
          userDetail.user,
        );

        dispatch(
          updateSelected({
            outlet: res?.data?.[2]?.[0],
            // dealer: res?.data?.[1]?.[0],
            dealer: res?.data?.[1]?.find(
              (dealer) => dealer.Name === userDetail.user,
            ),
            otherMenuItems: res?.data?.[4],
            isCostShow: res?.data?.[5]?.[0]?.value === "YES",
            partyWiseRate: res?.data?.[5]?.[1]?.value === "YES",
          }),
        );
        // setPartyName(res.data[0][0]);
      } catch (error) {
        if (
          (error.response && error.response.status === 403) ||
          error.response.status === 401
        ) {
          redirectUrl();
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch, userDetail.user]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(baseUrl + getBatch, { withCredentials: true })
      .then((res) => {
        dispatch(
          updateSelected({
            BatchNo: res?.data?.[0]?.batchno,
          }),
        );
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (
          (error.response && error.response.status === 403) ||
          error.response.status === 401
        ) {
          redirectUrl();
        }
      })
      .finally(setLoading(false));
  }, [dispatch]);

  return (
    <CardWrapper
      onDragStart={(e) => e.preventDefault()}
      onKeyDown={handleKeyDown}
    >
      <Container
        maxWidth="xl"
        sx={{
          py: 1.5,
          px: 0,
        }}
      >
        {loading && <CircularProgress />}
        <Box sx={{ py: 0 }}>
          <Suspense fallback={<SkeletonLoader />}>
            <SalesHeader loading={loading} setLoading={setLoading} />
          </Suspense>
          <Box sx={{ py: 0.5 }}>
            <Suspense fallback={<SkeletonLoader />}>
              <TableSection />
            </Suspense>
          </Box>
          <Box sx={{ py: 0.5 }}>
            <Suspense fallback={<SkeletonLoader />}>
              <Footer loading={loading} setLoading={setLoading} />
            </Suspense>
          </Box>
        </Box>
      </Container>
    </CardWrapper>
  );
}

export default SalesPos;
